import { render } from "./SubmissionTables.vue?vue&type=template&id=20be3484&scoped=true"
import script from "./SubmissionTables.vue?vue&type=script&lang=js"
export * from "./SubmissionTables.vue?vue&type=script&lang=js"

import "./SubmissionTables.vue?vue&type=style&index=0&id=20be3484&scoped=true&lang=css"

import exportComponent from "/Users/yunlian/Documents/ccar.fun/purepay/new-pay3-cs-frontweb/new-pay3-cs-frontweb2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20be3484"]])

export default __exports__